'use client';

import { environment } from '@/config/environment';
import { useEffect } from 'react';

/**
 * Overrides console methods to suppress logging in production.
 * When debug.console is false, all console output is silenced.
 */
export default function ConsoleOverride() {
  useEffect(() => {
    if (environment.debug.console) {
      return; // Keep console enabled
    }

    // Store original console methods (in case we need them later)
    const originalConsole = {
      log: console.log,
      warn: console.warn,
      info: console.info,
      debug: console.debug,
      error: console.error,
    };

    // Create no-op function
    const noop = () => {};

    // Override all console methods
    console.log = noop;
    console.warn = noop;
    console.info = noop;
    console.debug = noop;
    // Keep console.error for critical issues that should still be visible
    // console.error = noop;

    // Cleanup: restore original console on unmount (mainly for dev hot reload)
    return () => {
      console.log = originalConsole.log;
      console.warn = originalConsole.warn;
      console.info = originalConsole.info;
      console.debug = originalConsole.debug;
      // console.error = originalConsole.error;
    };
  }, []);

  return null;
}
